'use client'
import React, { ReactElement } from 'react'
import { TableProvider } from '../../../providers'
import { TableSizes, TableVariants } from '../../../types'
import { Column, TableHeaderVariants } from '../../../types'
import { TableContainer } from './partials'

export interface TableProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
    columns: Column[]
    isCollapsible?: boolean
    isEditable?: boolean
    isLoading?: boolean
    pagination?: ReactElement
    size?: TableSizes
    renderTbodyElement?: boolean
    sortHandler?: (sortBy: string) => void
    variant?: TableVariants
    headerVariant?: TableHeaderVariants
    hideHeader?: boolean
    hasBorder?: boolean
    hasBackground?: boolean
    'data-testid'?: string
}

export const Table = ({
    children,
    columns,
    isCollapsible = false,
    isEditable = false,
    isLoading = false,
    pagination,
    size,
    renderTbodyElement,
    sortHandler,
    variant = TableVariants.STRETCHED,
    headerVariant = TableHeaderVariants.REGULAR,
    hideHeader = false,
    hasBorder = true,
    hasBackground = true,
    ...props
}: TableProps) => {
    return (
        <TableProvider
            columns={columns}
            isCollapsible={isCollapsible}
            isEditable={isEditable}
            size={size}
            sortHandler={sortHandler}
            hasBorder={hasBorder}
            hasBackground={hasBackground}
            variant={variant}
            hideHeader={hideHeader}
            headerVariant={headerVariant}
            isLoading={isLoading}
        >
            <TableContainer
                renderTBodyElement={renderTbodyElement !== false ? true : false}
                {...props}
                pagination={pagination}
            >
                {children}
            </TableContainer>
        </TableProvider>
    )
}
